<template>

  <div>

    <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>

    <v-snackbar
        v-model="snackbar.show"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.message }}
    </v-snackbar>

    <v-card color="white" class="card-border">
      <v-system-bar height="45" window color="itoviGrayLight">
        <h2 class="card-header-text">Notifications</h2>
        <v-spacer></v-spacer>
      </v-system-bar>

      <div v-if="!(!!user && !!email_notifications)" class="pa-4">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>
      <div v-if="!!user && !!email_notifications" class="card-body">


        <v-layout align-top row wrap>
          <span class="txt-bold"> All Email Notifications</span>
          <v-spacer></v-spacer>
          <v-flex shrink class="text-xs-right pt-0 pb-0 mt-0 mb-0">
            <v-switch v-model="allEmailNotificationsSelected" @change="toggleAllEmailNotifications" class="pt-0 pb-0 mt-0 mb-0" color="primary"></v-switch>
          </v-flex>
        </v-layout>

        <template v-for="(item, index) in email_notifications">
          <v-layout :key="index" align-top row wrap>
            <v-flex d-flex xs9 class="ma-0 pb-3">
              <v-layout column wrap>
                <div>{{ item.name }}</div>
                <div class="sm-lbl">{{ getEmailNotificationDescription(item.id) }}</div>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink class="text-xs-right pt-0 pb-0 mt-0 mb-0">
              <v-switch v-model="email_notifications[index].subscribed" @change="emailNotificationChange(item.id)" class="pt-0 pb-0 mt-0 mb-0" color="primary"></v-switch>
            </v-flex>
          </v-layout>
        </template>

        <v-divider class="mt-4 mb-3"></v-divider>

        <v-layout align-top row wrap>
          <span class="txt-bold">Push Notifications</span>
          <v-spacer></v-spacer>
          <v-flex shrink class="text-xs-right pt-0 pb-0 mt-0 mb-0">
            <v-switch v-model="user.push_notifications" @change="pushNotificationChange" class="pt-0 pb-0 mt-0 mb-0" color="primary"></v-switch>
          </v-flex>
        </v-layout>


      </div>

    </v-card>
  </div>

</template>

<script>
  import api from "../../../services/api_endpoints";
  import store from '../../../store'
  import LoadingDialog from "../../LoadingDialog"
  import subscribeToStore from "@/mixins/subscribeToStore";

  const promotionsDesc = 'You\'ll want this box checked. Keep up-to-date with iTOVi promotions and special offers!';
  export default {
    components: {
      LoadingDialog
    },
    data: ()=> ({
      showLoadingDialog: false,
      allEmailNotificationsSelected: false,
      snackbar: {
        show: false,
        timeout: 2500,
        message: "Error saving notification preferences",
      },
      email_notifications: store.state.emailNotifications,
      user: store.state.user,
      emailNotificationDescriptions: [
        {
          id: 'd56c7bfb99',
          name: 'Events',
          description: 'Be in the know for upcoming events!'
        },
        {
          id: '848812abf1',
          name: 'Updates',
          description: 'See what\'s new with our app & scanner!'
        },
        {
          id: '45307c0d0d',
          name: 'Newsletter',
          description: 'iTOVi\'s newsletters, company updates, etc.'
        },
        {
          id: 'ff9dc8b766',
          name: 'Surveys',
          description: 'Tell us about your experience, how we can improve, and any other feedback you’d like to share.'
        },
        {
          id: 'ed28f6a4e3',
          description: promotionsDesc
        },
        {
          id: '2d6ba483e8',
          description: promotionsDesc
        },
        {
          id: '238f0e0ffa',
          description: promotionsDesc
        },
        {
          id: '7ae62de190',
          description: promotionsDesc
        }
      ]
    }),
    props: {
      onLoaded: Function,
    },
    mixins: [subscribeToStore],
    created(){
      this.fetchData()
    },
    mounted() {
      this.subscribeToStore(['user'])
    },
    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed(2);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      async fetchData() {
        this.email_notifications = await api.getEmailNotifications();
        this.allEmailNotificationsSelected = this.email_notifications.findIndex((item) => item.subscribed === false) === -1;
        if (this.isFunction(this.onLoaded)) this.onLoaded();
      },
      async toggleAllEmailNotifications(val) {
        this.showLoadingDialog = true;
        for (let i = 0; i < this.email_notifications.length; i++) {
          // no need to update it if it's already correct
          if (this.email_notifications[i].subscribed !== !!val) {
            this.email_notifications[i].subscribed = !!val;
            await this.emailNotificationChange(this.email_notifications[i].id)
          }
        }
        this.showLoadingDialog = false;
        // console.log('toggleAllEmailNotifications', !!val)
      },
      getEmailNotificationDescription(id) {

        const match = this.emailNotificationDescriptions.filter(obj => {
          return obj.id === id
        });

        if (match.length > 0) {
          return match[0].description
        }
        return null

      },
      async emailNotificationChange(id) {
        let result = this.email_notifications.filter(obj => {
          return obj.id === id
        })[0];

        const newVal = !!result.subscribed;

        let response = await api.submitEmailNotificationChange(id, newVal);
        if (!response.success) {
          this.snackbar.show = true;
          let index = this.email_notifications.findIndex((value) => value.id === id);
          this.email_notifications[index].subscribed = !this.email_notifications[index].subscribed
        }

        this.allEmailNotificationsSelected = this.email_notifications.findIndex((item) => item.subscribed === false) === -1
      },
      async pushNotificationChange() {
        const val = this.user.push_notifications;
        let response = await api.submitPushNotificationChange(val);

        // we don't need to manually set this setting value back
        // b/c it is subscribed to changes on the state
        if (!response.success) {
          this.snackbar.show = true
        }

      },
    },
  }
</script>
